export const GIGS_PER_PAGE = 25

export const MAX_PHOTO_SIZE_MB = 19

export const MAX_PHOTO_SIZE_BYTES = MAX_PHOTO_SIZE_MB * 1024 * 1024

export const SHIPMENT_TYPE_UNSPECIFIED = 'Unspecified'

export const TRAINING_CERTS = {
  PROP22: 'prop22_training',
  ONBOARDING: 'basic_driver',
  TRAILER_HITCH: 'trailer_hitch',
  COMMITTED_CAPACITY: 'committed_capacity',
  RETURNS: {
    CERT: 'roadie_returns',
    ELIGIBLE_CERT: 'roadie_returns_eligible',
  },
  THRESHOLD: {
    CERT: 'threshold_delivery',
    ELIGIBLE_CERT: 'threshold_delivery_eligible',
  },
  PHARMACY: {
    CERT: 'pharmacy_gig',
  },
  ROADIE_XD: {
    CERT: 'roadie_xd',
  },
  // TODO: is roadie_xd_beta still supported?
  ROADIE_XD_BETA: {
    CERT: 'roadie_xd_beta',
  },
  MAIL_INNOVATIONS: {
    CERT: 'mail_innovations',
  },
} as const
